module.exports = __webpack_public_path__ + "static/media/coronavirus_logo.4732be2b.jpg";